var map = {
	"./auth.js": "./src/api/model/auth.js",
	"./business.js": "./src/api/model/business.js",
	"./businessCalendar.js": "./src/api/model/businessCalendar.js",
	"./common.js": "./src/api/model/common.js",
	"./delivery.js": "./src/api/model/delivery.js",
	"./demand.js": "./src/api/model/demand.js",
	"./demo.js": "./src/api/model/demo.js",
	"./file.js": "./src/api/model/file.js",
	"./forum.js": "./src/api/model/forum.js",
	"./goods.js": "./src/api/model/goods.js",
	"./log.js": "./src/api/model/log.js",
	"./manage.js": "./src/api/model/manage.js",
	"./merchantApply.js": "./src/api/model/merchantApply.js",
	"./notify.js": "./src/api/model/notify.js",
	"./order.js": "./src/api/model/order.js",
	"./page.js": "./src/api/model/page.js",
	"./pub.js": "./src/api/model/pub.js",
	"./requirement.js": "./src/api/model/requirement.js",
	"./smsCode.js": "./src/api/model/smsCode.js",
	"./special.js": "./src/api/model/special.js",
	"./store.js": "./src/api/model/store.js",
	"./system.js": "./src/api/model/system.js",
	"./wx.js": "./src/api/model/wx.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/api/model sync \\.js$";